import { HashRouter } from 'react-router-dom';
import initRouter from './router';
import HHeader from '@/components/HHeader';
import LoadingGlobal from '@/components/LoadingGlobal';
import { isEnv } from '@/utils';
const App = () => {
  return (
    <HashRouter>
      {isEnv() === 'App' && <HHeader />}
      {LoadingGlobal && <LoadingGlobal />}
      {initRouter()}
    </HashRouter>
  );
};
export default App;
